import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';

import { Button, Tree, Card, Tag } from 'element-ui';

Vue.use(Button);
Vue.use(Tree);
Vue.use(Card);
Vue.use(Tag);
